<template>
    <div class="bottom_pagin">
        <el-pagination
                background
                layout="total, prev, pager, next"
                @current-change="getData"
                :current-page.sync="page"
                :page-size="pageSize"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex'
    import {clone} from "../../global/utils";

    export default {
        name: "pageView",
        props: [
            'currentPage',
            'pageSize',
            'total',
        ],
        data() {
            return {
                page: 1,
                size: 0,
                tot: 0,
            }
        },
        watch: {
            currentPage() {
                this.page = Number(clone(this.currentPage))
            },
            pageSize() {
                this.size = Number(clone(this.pageSize))
            },
            total() {
                this.tot = Number(clone(this.total))
            },
        },
        mounted() {

        },
        methods: {
            getData(v) {
                this.$emit('getTableList', v)
            },
        }
    }
</script>

<style scoped lang="scss">
    .bottom-pagin {
        padding: 5px 15px;
        /*background: #fff;*/
    }
</style>